// src/RegisterScreen.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, AlertCircle } from 'lucide-react';
import ReportIssueModal from './components/ReportIssueModal';

export default function RegisterScreen() {
  const navigate = useNavigate();
  const [opsId, setOpsId] = useState('');
  const [cpf, setCpf] = useState('');
  const [password, setPassword] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [erro, setErro] = useState('');
  const [isReportModalVisible, setIsReportModalVisible] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');

    if (password !== confirmarSenha) {
      setErro('As senhas não coincidem.');
      return;
    }

    try {
      await axios.post('/api/register', {
        ops_id: opsId,
        cpf: cpf,
        password: password,
      });

      alert('Cadastro realizado com sucesso!');
      navigate('/');
    } catch (error) {
      console.error('Erro no cadastro:', error);
      setErro(error.response?.data?.detail || 'Falha ao criar conta.');
    }
  };

  return (
    <div style={styles.wrapper}>
      {/* Faixa superior com a logo */}
      <div style={styles.header}>
        <img
          src={process.env.PUBLIC_URL + '/ic_target.png'}
          alt="SPX Logo"
          style={styles.logo}
        />
      </div>

      {/* Conteúdo branco abaixo */}
      <div style={styles.container}>
        {/* Botão de voltar */}
        <button onClick={() => navigate('/')} style={styles.backButton}>
          <ArrowLeft size={20} />
          <span style={styles.backText}>Voltar</span>
        </button>

        <h2 style={styles.title}>Cadastro</h2>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Dados cadastrais</h3>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Ops Id</label>
              <input
                type="number"
                placeholder="Insira seu Ops Id"
                value={opsId}
                onChange={(e) => setOpsId(e.target.value)}
                required
                style={styles.input}
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>CPF (somente números)</label>
              <input
                type="number"
                placeholder="Insira seu CPF"
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
                required
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Senha</h3>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Senha</label>
              <input
                type="password"
                placeholder="Insira uma senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={styles.input}
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Confirmação de Senha</label>
              <input
                type="password"
                placeholder="Confirme sua senha"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                required
                style={styles.input}
              />
            </div>
          </div>

          {erro && <p style={styles.errorText}>{erro}</p>}

          <button type="submit" style={styles.submitButton}>
            Criar Conta
          </button>
        </form>

        <div style={styles.footer}>
          <p style={styles.footerText}>Já possui uma conta?</p>
          <button
            type="button"
            onClick={() => navigate('/')}
            style={styles.footerLink}
          >
            Entrar
          </button>
        </div>
      </div>

      {/* Botão de relatar problema */}
      <button
        onClick={() => setIsReportModalVisible(true)}
        className="fixed bottom-6 right-6 bg-[#EE4D2D] text-white p-3 rounded-full shadow-lg hover:bg-[#D03F2A] transition-all duration-300 z-40 opacity-80 hover:opacity-100"
        title="Relatar um Problema"
      >
        <AlertCircle size={24} />
      </button>

      <ReportIssueModal
        isVisible={isReportModalVisible}
        onClose={() => setIsReportModalVisible(false)}
        screenName="register"
      />
    </div>
  );
}

// 🎨 Estilos (sem alterações)
const styles = {
  wrapper: {
    minHeight: '100vh',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    width: '100%',
    backgroundColor: '#EE4D2D',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 24,
    paddingBottom: 24,
  },
  logo: {
    height: 64,
    objectFit: 'contain',
  },
  container: {
    width: '100%',
    maxWidth: 400,
    backgroundColor: 'white',
    padding: '24px',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    marginTop: -16,
    boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#555',
    fontSize: 14,
    cursor: 'pointer',
    marginBottom: 24,
  },
  backText: {
    marginLeft: 6,
    fontSize: 16,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 24,
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  inputGroup: {
    marginBottom: 12,
  },
  label: {
    fontSize: 13,
    color: '#444',
    marginBottom: 4,
    display: 'block',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ccc',
    borderRadius: 8,
    fontSize: 14,
  },
  errorText: {
    color: 'red',
    fontSize: 13,
    textAlign: 'center',
    marginBottom: 8,
  },
  submitButton: {
    width: '100%',
    backgroundColor: '#EE4D2D',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    padding: '12px',
    fontWeight: 'bold',
    fontSize: 16,
    cursor: 'pointer',
    marginTop: 8,
  },
  footer: {
    marginTop: 24,
    textAlign: 'center',
  },
  footerText: {
    color: '#333',
    fontSize: 14,
    marginBottom: 4,
  },
  footerLink: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#2196F3',
    textDecoration: 'underline',
    fontSize: 14,
    cursor: 'pointer',
  },
};
